import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TokenGuardService } from './core/guards/token-guard.service';
import { ExternalInitializationComponent } from './external-initialization/external-initialization.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { LoginComponent } from './user-authentication/login/login.component';

const routes: Routes = [{
  path: 'user-authentication',
  loadChildren: () => import('./user-authentication/user-authentication-routing.module').then(m => m.UserAuthenticationRoutingModule),
},
{
  path: '',
  canActivate: [TokenGuardService],
  loadChildren: () => import('./feature-modules/feature-modules-routing.module').then(m => m.FeatureModulesRoutingModule),
},
{
  path: 'externalInitialization',
  component: LoginComponent
},
{
  path: 'externalInitialization/:id',
  component: ExternalInitializationComponent
},
{
  path: 'error',
  component: ErrorComponent
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
